module.exports = __webpack_public_path__ + "static/media/KSC.842e7127.png";